/* eslint-disable no-restricted-imports */
import React, {useState} from 'react'
import ReactDOM from 'react-dom'
import {AudioTabContent} from './AudioTabContent'
import {ControlsTabContent} from './ControlsTabContent'
import {DisplayTabContent} from './DisplayTabContent'
import {GameInfoTabContent} from './GameInfoTabContent'
import clsx from 'clsx'
import styles from './UIGameSettings.module.scss'
import {useUIGameSettingsContext} from '../../contexts/UIGameSettingsContext'
import {TranslationObject} from '@colonist/i18n'
import {T, t} from '../../common/T'
import {getImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'
import {Sprites} from '../../../../../code/client/shared/scripts/ui_game/UIGameImageDictionary'

export const UIGameSettings = ({
    containerRef,
}: {
    containerRef: React.Ref<HTMLDivElement> | null
}) => {
    const {isOpenSettings} = useUIGameSettingsContext()

    const SETTING_TABS: {
        id: string
        label: TranslationObject
        icon: string
    }[] = [
        {
            id: 'game-info',
            label: {key: 'strings:game.settings.gameInfoTab.title'},
            icon: getImagePath(`${Sprites.icon_info}.svg`),
        },
        {
            id: 'display',
            label: {key: 'strings:game.settings.displayTab.title'},
            icon: getImagePath(`${Sprites.icon_display}.svg`),
        },
        {
            id: 'audio',
            label: {key: 'strings:game.settings.audioTab.title'},
            icon: getImagePath(`${Sprites.icon_audio}.svg`),
        },
        {
            id: 'controls',
            label: {key: 'strings:game.settings.controlsTab.title'},
            icon: getImagePath(`${Sprites.icon_controls}.svg`),
        },
    ]

    const {closeSettings} = useUIGameSettingsContext()
    const [activeTab, setActiveTab] = useState(SETTING_TABS[0].id)

    return ReactDOM.createPortal(<div
        className={clsx(styles.gameSettingsContainer, {[styles.hidden]: !isOpenSettings})}
        ref={containerRef}>
        <div className={styles.headingContainer}>
            <img
                alt={t('strings:imgAlts.IconArrowPrevious')}
                className={styles.backButton}
                onClick={closeSettings}
                src={getImagePath(`${Sprites.icon_arrow}.svg`)}
            />
            <h1 className={styles.heading}><T id='strings:game.settings.title' /></h1>
        </div>
        <div className={styles.contentContainer}>
            <div className={styles.contentLeft}>
                {SETTING_TABS.map((tab) => (
                    <div
                        className={clsx(styles.tabButton, tab.id === activeTab && styles.active)}
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}>
                        <img alt={t(tab.label.key, tab.label.options)} className={styles.icon} src={tab.icon}/>
                        <T id={tab.label} />
                    </div>
                ))}
            </div>
            <div className={styles.contentRight}>
                {activeTab === 'game-info' && <GameInfoTabContent />}
                {activeTab === 'display' && <DisplayTabContent />}
                {activeTab === 'audio' && <AudioTabContent />}
                {activeTab === 'controls' && <ControlsTabContent />}
            </div>
        </div>
    </div>,
    document.body)
}
